import { Flex, Text } from '@chakra-ui/react';
import { Button, ButtonText, Callout } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import AuthorInfo from 'src/components/Submission/AuthorsTab/AuthorInfo';
import { useQuery } from '@tanstack/react-query';
import { fetchUserProfileData } from 'src/api/queries';
import { faWarning } from '@fortawesome/pro-solid-svg-icons';
import SummaryTab from 'src/components/Submission/AuthorsTab/AuthorSummary';
import { Link } from 'react-router-dom';
import SubmissionLoader from 'src/pages/Organization/Workspace/Submissions/SubmissionLoader';
import { IAuthor } from '@publishing-engine/domain/types/AuthorType';

export const updateProfileUrl = import.meta.env.VITE_IOPP_IDP_PROFILE_URL;

const checkObjectHasData = (data: IAuthor) => data && Object.keys(data)?.length;

const IOPPUserAccount = () => {
  const {
    data: authorData,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['user-profile'],
    queryFn: () => fetchUserProfileData()
  });

  const isDataMissing =
    authorData &&
    (!authorData?.user?.firstName ||
      !authorData?.user?.lastName ||
      !authorData?.user?.email ||
      !authorData?.user?.affiliationDetails?.organizationName);
  return (
    <Flex paddingX={16} direction={'column'} width="72rem" margin={'auto'}>
      <Flex
        width="100%"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        textStyle="textBody"
        marginBottom={4}
      >
        <Text textStyle="headingTitle">My Profile</Text>
        {authorData && checkObjectHasData(authorData) ? (
          <Link to={updateProfileUrl} target="_blank">
            <Button leftIcon={<FontAwesomeIcon icon={faPenToSquare} />}>
              Edit Profile
            </Button>
          </Link>
        ) : null}
      </Flex>
      {isLoading ? (
        <SubmissionLoader
          title="Loading Search Results"
          subTitle="We are retrieving your search results. This should only take a moment."
          bgColor="neutralSecondaryFill"
        />
      ) : isError && error ? (
        <SubmissionLoader
          title="Search Failed"
          subTitle="We encountered an issue connecting to the search service. Please check your connection or try again later."
          bgColor="errorPrimaryFill"
        />
      ) : (
        <>
          {isDataMissing && (
            <Flex direction="column" marginY={5}>
              <Callout
                customIcon={<FontAwesomeIcon icon={faWarning} />}
                heading="Missing Information"
                variant="attention"
                body="You are missing key sections in your profile. Update them on your IOPP account"
                action={
                  <Link to={updateProfileUrl} target="_blank">
                    <ButtonText>Update profile</ButtonText>
                  </Link>
                }
              />
            </Flex>
          )}
          {authorData && (
            <>
              <AuthorInfo
                user={authorData.user}
                additionalInformation={authorData.additionalInformation}
              />
              <SummaryTab
                data={{
                  affiliationDetails: authorData?.user?.affiliationDetails,
                  boardMemberships: authorData?.boardMemberships
                }}
                isProfileView={true}
              />
            </>
          )}
        </>
      )}
    </Flex>
  );
};

export default IOPPUserAccount;
